import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { query, where, getDocs, collection, updateDoc, doc, getDoc } from 'firebase/firestore';
import { db } from '../utils/firebaseConfig';
import GeneralNavbar from './GeneralNavbar';
import './PurchaseDetail.css';

const PurchaseDetail = () => {
  const { purchaseId } = useParams();
  const [purchase, setPurchase] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate(-1); // Vuelve a la página anterior en el historial
  };

  useEffect(() => {
    const fetchPurchaseDetails = async () => {
      try {
        const purchaseDoc = await getDoc(doc(db, 'compras', purchaseId));
        if (purchaseDoc.exists()) {
          setPurchase(purchaseDoc.data());
        } else {
          console.error('No se encontró la compra con el ID proporcionado');
        }
      } catch (error) {
        console.error('Error al obtener los detalles de la compra:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchPurchaseDetails();
  }, [purchaseId]);

  const calculateTotal = () => {
    if (!purchase || !purchase.cartItems) return 0;
    return purchase.cartItems.reduce((total, item) => {
      const finalPrice = item.discountedPrice || item.price; // Usar discountedPrice si existe, si no usar price
      return total + finalPrice * item.quantity;
    }, 0);
  };

  const handleCancelOrder = async () => {
    if (!purchase || !purchase.cartItems) return;
  
    try {
      // Actualizar el estado de la compra a "Cancelada"
      const purchaseRef = doc(db, 'compras', purchaseId);
      await updateDoc(purchaseRef, { status: 'Cancelada' });
  
      // Restablecer el stock de los productos
      for (const item of purchase.cartItems) {
        const productsRef = collection(db, 'products');
        const q = query(productsRef, where('id', '==', item.id)); // Buscar por el campo interno "id"
        const querySnapshot = await getDocs(q);
  
        if (!querySnapshot.empty) {
          querySnapshot.forEach(async (docSnapshot) => {
            const currentStock = docSnapshot.data().stock || 0;
            await updateDoc(doc(db, 'products', docSnapshot.id), {
              stock: currentStock + item.quantity,
            });
          });
        } else {
          console.warn(`Producto no encontrado: ${item.id}`);
        }
      }
  
      // Actualizar el estado local
      setPurchase({ ...purchase, status: 'Cancelada' });
      setError('');
    } catch (err) {
      console.error('Error al cancelar la compra:', err);
      setError('Hubo un problema al cancelar la compra.');
    }
  };
  
  
  
  

  if (loading) {
    return <p className="centered-text">Cargando...</p>;
  }

  if (!purchase) {
    return <p className="centered-text">No se encontraron detalles de la compra</p>;
  }

  const total = calculateTotal();

  return (
    <div>
      <GeneralNavbar title="Detalle de Compra" onBackClick={handleBackClick} />

      <div className="purchase-detail-container">
        <p><strong>Compra ID:</strong> {purchase.idTracker}</p>
        <p><strong>Nombre:</strong> {purchase.name} {purchase.apellido}</p>
        <p><strong>Email:</strong> {purchase.email}</p>
        <p><strong>Estado:</strong> {purchase.status}</p>
        <p><strong>Fecha:</strong> {new Date(purchase.timestamp.seconds * 1000).toLocaleString()}</p>
        <p><strong>Método de Pago:</strong> {purchase.paymentMethod}</p>

        {/* Mostrar comprobante solo si el método de pago es "Mercado Pago" */}
        {purchase.paymentMethod === "Mercado Pago" && purchase.paymentId && (
          <p><strong>Comprobante:</strong> {purchase.paymentId}</p>
        )}


        {/* Mostrar los nuevos campos según la opción de entrega */}
        {purchase.deliveryOption === "local" && purchase.selectedStore && (
          <p><strong>Tienda Seleccionada:</strong> {purchase.selectedStore}</p>
        )}

        {purchase.deliveryOption === "domicilio" && (
          <>
            {purchase.address && <p><strong>Dirección:</strong> {purchase.address}</p>}
            {purchase.addressNumber && <p><strong>Número:</strong> {purchase.addressNumber}</p>}
            {purchase.apartment && <p><strong>Departamento:</strong> {purchase.apartment}</p>}
          </>
        )}


        <h3>Productos Comprados</h3>
        {purchase.cartItems && purchase.cartItems.length > 0 ? (
          <div>
            <table className="products-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Nombre</th>
                  <th>Descripción</th>
                  <th>Precio</th>
                  <th>Cantidad</th>
                  <th>Subtotal</th>
                </tr>
              </thead>
              <tbody>
                {purchase.cartItems.map((item, index) => (
                  <tr key={index}>
                    <td data-label="ID:">{item.id}</td>
                    <td data-label="Nombre:">{item.name}</td>
                    <td data-label="Descrip:">{item.description}</td>
                    <td data-label="Precio:">${item.discountedPrice ? item.discountedPrice : item.price}</td>
                    <td data-label="Cantidad:">{item.quantity}</td>
                    <td data-label="Subtotal:">
                      ${(item.discountedPrice ? item.discountedPrice : item.price) * item.quantity}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="totals-container">
              <p><strong>Total:</strong> ${total.toFixed(2)}</p>
            </div>
          </div>
        ) : (
          <p>No se encontraron productos en esta compra.</p>
        )}

        {purchase.status !== 'Cancelada' && (
          <button className="cancel-button" onClick={handleCancelOrder}>
            Cancelar Compra
          </button>
        )}

        {error && <p className="error-text">{error}</p>}
      </div>
    </div>
  );
};

export default PurchaseDetail;

